import WebHeader from '@shared/components/core/headers/WebHeader';
import HeaderOnlyLayout from '@shared/components/core/structure/HeaderOnlyLayout';
import * as React from 'react';

export interface IAdminHeaderOnlyLayoutProps {
    children: React.ReactNode;
}

export default function AdminHeaderOnlyLayout({ children }: IAdminHeaderOnlyLayoutProps) {
    return <HeaderOnlyLayout headerContent={<WebHeader />}>{children}</HeaderOnlyLayout>;
}
